import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { localize } from "../data/blog";

const LOCALE_MAP = { tr: "tr-TR", en: "en-US", ru: "ru-RU" };

export default function BlogCard({ post }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage || "tr";
  const p = localize(post, lang);
  const dateStr = new Date(post.date).toLocaleDateString(LOCALE_MAP[lang] || "tr-TR", {
    year: "numeric", month: "short", day: "numeric",
  });

  return (
    <Link to={`/blog/${post.slug}`} className="post-card">
      <div className="post-cover">
        <span className="post-cat">{t(`blog.categories.${post.category}`)}</span>
        {post.cover ? (
          <img src={post.cover} alt={p.title} loading="lazy" />
        ) : (
          <>
            <span className="pc-grid" />
            <span className="pc-mark">DEMAR</span>
          </>
        )}
      </div>
      <div className="post-body">
        <div className="post-meta">
          <span>{dateStr}</span>
          <span>·</span>
          <span>{post.readingMinutes} {t("blog.minRead")}</span>
        </div>
        <h3 className="post-title">{p.title}</h3>
        <p className="post-excerpt">{p.excerpt}</p>
        <span className="post-more link-arrow">{t("blog.readMore")} →</span>
      </div>
    </Link>
  );
}
